import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { MD5 } from 'crypto-js';

import { UserService } from '@shared/services';

@Injectable()
export class DefaultHeadersInterceptor implements HttpInterceptor {
  constructor( private userService: UserService ) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(!request.url.includes('logstash')) request = this.addDefaultHeaders(request);
    return next.handle(request);
  }

  private addDefaultHeaders(request: HttpRequest<any>): HttpRequest<any> {
    let req = request.clone({ setHeaders: {
      'T-MT-Locale':  'de',
      'T-MT-App-Name': this.userService.isInternal ? 'de.tempton.internal_portal' : 'de.tempton.customer_portal',
    }});


    if (request.url.includes('/v3/')) req = req.clone({ setHeaders: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json'
    }});
    if (request.url.includes('api/portal/v3') || request.url.includes('api/files')) {
      req = req.clone({
        setHeaders: {
          'T-MT-UUID': localStorage.getItem('uuid') || this.generateUUID()
        }
      });
    }
    return req;
  }

  private getUserUniqueData(): string {
    const userAgent        = navigator.userAgent;
    const screenResolution = `${screen.width}x${screen.height}`;
    const timeZone         = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const language         = navigator.language;
    const date             = new Date().toISOString();
    return `${userAgent}-${screenResolution}-${timeZone}-${language}-${date}`;
  }

  private generateUUID(): string {
    const uniqueData = this.getUserUniqueData();
    const hash       = MD5(uniqueData).toString();
    let uuid         = `${hash.substring(0, 8)}-${hash.substring(8, 4)}-${hash.substring(12, 3)}-${hash.substring(15, 4)}-${hash.substring(19, 12)}`;
    localStorage.setItem('uuid', uuid);
    return uuid;
  }

}
